<sync-dialog 
    [config]="{
        title: 'New folder',
        isClosable: true,
        actionButton: folderType === 'folder' ? 'Create' : 'Continue',
        cancelButton: 'Cancel',
        onActionClick: createFolder,
        onCancelClick: closeDialog,
        isActionButtonDisabled: (errors.length > 0 || errorMessage.length > 0 || (folderType === 'shared-folder' && isSharedFolder)),
        isButtonLoading: isLoading,
        closeIcon: closeIconName
    }"
    [open]="showDialog && !openShareFolderDialog" [isFullScreen]="isSmallScreen" [onClose]="closeDialog">
    <div class="new-folder-container">
        <app-error *ngIf="errcode" [errcode]="errcode"></app-error>
        <div class="folder-type-container" *ngIf="showFolderType">
            <div class="caption">
                Folder type
            </div>
            <div class="file-type">
                <div class="folder-type-card" [class.selected]="folderType === 'folder'" (click)="onSelect('folder')">
                    <sync-icon name="folder" iconSize="large"></sync-icon>
                    <div class="text-wraper">
                        <div class="body-1 text">
                            Folder
                        </div>
                        <div class="caption sub-text">
                            Only I can access this folder 
                        </div>
                    </div>
                </div>

                <div class="folder-type-card" [class.selected]="folderType === 'shared-folder'"
                    (click)="onSelect('shared-folder')">
                    <sync-icon name="folder-shared-team" iconSize="large"></sync-icon>
                    <div class="text-wraper">
                        <div class="body-1 text">
                            Shared folder
                        </div>
                        <div class="caption sub-text">
                            Invite others to collaborate
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sync-text-field
            *ngIf="!(folderType === 'shared-folder' && isSharedFolder)"
            #folderNameInput
            label="Folder name" placeholder="New folder" [(value)]="folderName" [inputChange]="folderNameChange"
            [errorMessage]="errorMessage"></sync-text-field>
        <div class="secured">
            <sync-icon iconSize="small" name="lock-encrypted"></sync-icon>
            Secured by Sync
        </div>

        <sync-alert
            type="warning"
            *ngIf="folderType === 'shared-folder' && isSharedFolder"
            [showLeadIcon]="true"
            leadIcon="warning"
            [showActions]="true"
            [showCloseButton]="false"
            description="Shared folders cannot be created inside another shared folder."      
            [primaryButtonConfig]="{ label: 'Learn more', onClick: learnMoreClick }"
        />
    </div>
</sync-dialog>
<app-dialog-share-new
    *ngIf="openShareFolderDialog"
    [isNewFolder]="true"
    [filename]="folderName"
    [(showDialog)]="openShareFolderDialog"
    [pid]="syncPid"
    (shareFolderSuccess)="onShareFolderCreateSuccess($event)"
    (cancel)="closeDialog()"    
>
</app-dialog-share-new>
<app-verify-email-required *ngIf="showEmailVerifyDialog" [cancelButtonText]="'Close'" (showDialogChange)="closeEmailVerifyDialog()"
[message]="'Your account must be verified in order to invite new users.'"></app-verify-email-required>